export default {
  allLandings: (state) => {
    return state.landings;
  },
  landingData: (state) => {
    return state.landing;
  },
};
